import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/cart/services/cart.service';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ProductService } from 'src/app/product/services/product.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-recommended-products',
    templateUrl: './recommended-products.component.html',
    styleUrl: './recommended-products.component.scss',
    standalone: false
})
export class RecommendedProductsComponent implements OnInit {
  global_data:any = {};
  commonBottonText: any = 'Ok';
  popupMessage = ''
  bsModalRef: BsModalRef;
  recommendedProducts: Array<any> = [];
  noRecord: boolean = true;
  contentLoaded: boolean = false;
  miniCartDetails: any;
  profileImagePath = environment.s3_path + '/' + environment.profileFolder
  imagePath = environment.s3_path + '/' + environment.product_image_folder + '/'
  recommendationListSubscription$!:Subscription;
  dbc = [{'name':'anshu'}]
  constructor( private productService: ProductService,
   private statePersiste :StatePersistService, private modalService: BsModalService,
   private alertService: AlertService, private router: Router, private cartService: CartService,
   private sharedService: SharedService
  ) {
    
  }
  ngOnInit(): void {
    window.scrollTo(0, 0)
    this.statePersiste.setLocalStorage('address-disabled', true)
    this.statePersiste.setLocalStorage('retailer-disabled', true)
    this.statePersiste.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersiste.getLocalStorage('global_data')
    })
    this.statePersiste.watchRecommendedProductsStorage().subscribe(message => {
      this.recommendedProductsList()
    })
    
    this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    this.statePersiste.watchMiniCartDetailChange().subscribe(message => {
      this.miniCartDetails = this.statePersiste.getLocalStorage('mini_cart_details')
    })
    this.recommendedProductsList()
  }

  toInteger(value) {
    return parseInt(value)
  }
  popup(template: TemplateRef<any>){
    this.bsModalRef = this.modalService.show(template,  Object.assign({}, { class: 'modal-dialog-centered custom-modal confirm' }));
  }

  recommendedProductsList(){
    this.contentLoaded = false;
    this.recommendationListSubscription$ = this.productService.productBoxes().subscribe({
      next:(response:any)=>{
        if(response.response){
          this.noRecord = true;
          const dataobj = response.response
          this.recommendedProducts = [...dataobj];
          this.contentLoaded = true;
          
          let updatedRecommendation = [];
          for (const recom of this.recommendedProducts) {
            let productList = [];
            for (const element of recom['products']){
              if(this.global_data?.vat_exempt == 1){
                element['margin'] = this.sharedService.getStoreVatFreeMargin(element)
              }
              productList.push(element)
            }
            recom['products'] = productList
            updatedRecommendation.push(recom)
          }
          this.recommendedProducts = [...updatedRecommendation]
          if (this.recommendedProducts.length >0){
            this.noRecord = false;
          }
          
        }}}
    )
      }
    
    notInteretedSuggest(product, recommendation_id){
      this.productService.notInterestProduct({'product_id': product.product_id, 'recommendation_id':recommendation_id})
        .subscribe(
          data => {
            for (let i = 0; i < this.recommendedProducts.length; i++) {
              if (this.recommendedProducts[i].recommend_id == recommendation_id){
                this.recommendedProducts[i].products = this.recommendedProducts[i].products.filter(item => item.product_id !== product.product_id);
                this.recommendedProducts[i]['total_products'] = this.recommendedProducts[i]['total_products'] -1
                
              }
              if (this.recommendedProducts[i]['total_products'] == 0){
                this.recommendedProducts = this.recommendedProducts.filter(item => item.recommend_id != recommendation_id)
              }
              if (this.recommendedProducts.length == 0){
                this.noRecord = true;
              }
            }
            
          }
        );
    }

    qytChange(product, qyt, template, recommend_id) {
    
      if (product.item_id !== '') {
        if (qyt == 0){
          for (let i = 0; i < this.recommendedProducts.length; i++) {
            if (this.recommendedProducts[i].recommend_id == recommend_id){
              for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                  this.recommendedProducts[i].products[j]['qty'] = 0
                }
              }
              
            }
          }
          this.removeItem(product, recommend_id)
        }else{
          this.qytUpdate(product, String(qyt), template, recommend_id)
        }
        
      }
      else {
        for (let i = 0; i < this.recommendedProducts.length; i++) {
          if (this.recommendedProducts[i].recommend_id == recommend_id){
            for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
              if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
      
                this.recommendedProducts[i].products[j]['qty'] = String(qyt)
              }
            }
           
            
          }
        }
        
      }
    }
  
    qytUpdate(product, qyt, template, recommend_id) {
      this.productService.qytUpdate({ 'item_id': parseInt(product.item_id), 'qty': qyt })
        .subscribe(
          data => {
            if (data.response) {
              this.popupMessage = ''
              if (data.status == 1169) {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){

                      for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                        if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                          this.recommendedProducts[i].products[j]['qty'] = '1'
                          this.recommendedProducts[i].products[j]['item_id'] = ''
                          this.recommendedProducts[i].products[j]['back_in_stock'] = '0'
                        }
                      }
                    }
                   
                    
                  }
              }
              else if(data.status == 2212){
                this.alertService.error(data.response)
              for (let i = 0; i < this.recommendedProducts.length; i++) {
                if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = data.response.qty
                      }
                  }
                  }
                 
                  
                }
            }
              else if(data.status == 1180){
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
              
              for (let i = 0; i < this.recommendedProducts.length; i++) {
                if (this.recommendedProducts[i].recommend_id == recommend_id){
                  for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                    if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                      this.recommendedProducts[i].products[j]['qty'] = data.response.qty
                    }
                }
                  }
                 
                  
                }
              const currentUrl = this.router.url;
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate([currentUrl]);
                });
              }
              else if (data.status == 1163) {
                this.alertService.error(data.response)
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                  this.recommendedProducts[i].products = this.recommendedProducts[i].products.filter(item => item.product_id !== product.product_id);
                    }
                  }
              }
              else {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = qyt
                      }
                    }
                  }
                }
              }
              this.statePersiste.emitminiCartData('min cart update')
  
            }
  
          }
        );
    }

    addToCart(product, qyt, template: any, type: any, template2:any, recommend_id) {
      let dataObj
      if (product.qty == '') {
        qyt = '1'
      }
      dataObj = {
        "cart_item": {
          "sku": product.sku,
          "qty": qyt
        }
      }
      
      this.productService.addToCart(dataObj)
        .subscribe(
          data => {
            if (data.response) {
              this.popupMessage = ''
              if (data.status == 2212) {
                this.alertService.error(data.response.msg)
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = '1'
                      }
                  }
                }}
              }
              else if (data.status == 1169) {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = '1'
                        this.recommendedProducts[i].products[j]['back_in_stock'] = '0'
                      }
                    }
                  }}
              }
              else if(data.status == 1180){
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = '1'
                      }
                    }
                  }}
              }
              else if (data.status == 1168) {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; i < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = '1'
                        this.recommendedProducts[i].products[j]['back_in_stock'] = '0'
                      }
                    }
                  }}
                this.popupMessage = data.response
                this.commonBottonText = "Ok, Don't show this again"
                this.popup(template2)
              }
              else if (data.status == 1163) {
                this.alertService.error(data.response)
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    this.recommendedProducts[i].products = this.recommendedProducts[i].products.filter(item => item.product_id !== product.product_id);
                  }}
              }
              else {
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['qty'] = String(qyt)
                        this.recommendedProducts[i].products[j]['item_id'] = data.response.item_id
                      }
                    }
                  }}
                var storeCount
                storeCount = this.statePersiste.getLocalStorage('selectedStoreAddress')
                if (template && storeCount['totalStoreCount'] > 1){
                  this.popup(template)
                }
  
              }
              this.statePersiste.emitminiCartData('min cart update')
  
            }
  
          }
        );
    }
  
    removeItem(product, recommend_id){
      let fordata;
      fordata = {'item_id': product.item_id}
      this.cartService.removeItem(fordata)
        .subscribe(
          data => {
            if (data.response) {
              if(data.status == 1180){
                localStorage.setItem('closeStorInfoMessage', data.response.msg)
                document.getElementById("openclosedStoreInfo").click();
                const currentUrl = this.router.url;
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate([currentUrl]);
                });
              }
              else if (data.status == 2212){
                this.alertService.error(data.response)
              }
              else{
                for (let i = 0; i < this.recommendedProducts.length; i++) {
                  if (this.recommendedProducts[i].recommend_id == recommend_id){
                    
                    for (let j = 0; j < this.recommendedProducts[i].products.length; j++) {
                      if (this.recommendedProducts[i].products[j]['product_id'] == product.product_id) {
                        this.recommendedProducts[i].products[j]['back_in_stock'] = ''
                        this.recommendedProducts[i].products[j]['item_id'] = ''
                      }
                    }
                  }}
                this.statePersiste.emitminiCartData('update mini cart')
                this.alertService.success('Product removed.')
              }
              
            }
              
            }
  
        )
  
    }
    }
